import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ErrorImage from '@components/Image/components/ErrorImage';
import { getCartImageProduct } from '@services/images.service';

const MISSING_IMAGE = '/menu-sections/new-verticals/default/';

const Image = styled.img`
  border-radius: 6px;
  width: 62px;
  height: 62px;
`;

const ImageWrapper = styled.div`
  width: 62px;
  height: 62px;
  position: relative;
  padding-right: 12px;
`;

function ItemImage({ image }) {
  let visibleImage = <ErrorImage />;
  if (image && image !== MISSING_IMAGE) {
    visibleImage = <Image src={`${getCartImageProduct(image)}`} />;
  }
  return <ImageWrapper>{visibleImage}</ImageWrapper>;
}

ItemImage.propTypes = {
  image: PropTypes.string,
};

export default ItemImage;
